// removed by extract-text-webpack-plugin
module.exports = {"header":"_15-A7r0N531vNJ5cJrw4an","icon":"KDr8lQebhQg2YATajUZUJ"};


//////////////////
// WEBPACK FOOTER
// ./src/page/css/template.css
// module id = 1391
// module chunks = 0